// percentage.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sheetPercentage'
})
export class SheetPercentagePipe implements PipeTransform {
  transform(activeSheets: number, totalSheets: number): any {
    if (!totalSheets || totalSheets === 0) {
      return '0.00';
    }
    const percentage = (activeSheets / totalSheets) * 100;

    return +percentage.toFixed(2);
  }
}
